<template>
  <div class="table_wrap">
    <div class="filter_row">
      <div class="filter_content language_filter mb10">
        <span class="filter_title mr10 verti-middle">언어</span>
        <el-select v-model="langOption" class="select faq_select mr5"
                   @change="setFilterArrayFunc('la', langOption)">
          <el-option :value="''" :label="'전체'"></el-option>
          <el-option v-for="(data, value, index) in languageList" :key="`termsLanguage${value}`"
                     :label="data.c_lang_ko" :value="Number(data.c_idx)"></el-option>
        </el-select>
      </div>
    </div>
<!--    <span class="total_length">총 {{ paginationData.total }}개 </span>-->
    <el-table :data="termsData"
              class="list-table"
              header-cell-class-name="list-header"
              empty-text="데이터가 없습니다."
              height="695"
    >
      <el-table-column
          class="table_no"
          type="index"
          label="No"
          width="90"
          class-name="num text-center"
          :index="tableIdx"
      >
      </el-table-column>
      <el-table-column label="언어" min-width="400" class-name="text-center">
        <template slot-scope="scope">
                    <span>
<!--                      {{ scope.row.c_config }}-->
                        {{ returnLang(scope.row.c_language) }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="옵션" min-width="90" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info">
            <el-button class="com_btn" @click="goDetail(scope.row.c_type, scope.row.c_idx)">
              상세
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import util from "@/mixins/util";
import {appLanguage} from "@/service/languageService"

export default {
  name: "TermsListDefaultLayout",
  mixins: [],
  inject: ['setFilter'],
  components: {},
  provide() {
    return {}
  },
  props: {
    termsData: {default: () => []},
    paginationData: {default: {total: 0}},
    filterData: {
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      langOption: '',
      languageList: appLanguage,
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    // goDetail(row) {
    //   let type = row.c_type;
    //   this.$router.push(`/site/terms/${type}/${row.c_idx}`)
    // },
    goDetail(type, key) {
      console.log(type)
      console.log(key)
      this.$router.push(`/site/terms/${type}/${key}`);
    },
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
    returnLang(lang){
      switch (lang) {
        case 1 : {
          return '한국어'
        }
        case 3 : {
          return '중국어'
        }
        case 30 : {
          return '영어'
        }
        default : {
          return '-'
        }
      }
    },
    setFilterArrayFunc(key, value) {
      let arr = []
      if (!util.isEmpty(value)) {
        arr.push(value)
      }
      this.setFilter(key, arr);
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
